<template>
  <el-dialog :visible.sync="visible" :title="title" width="1200px" class="check-dialog">
    <div class="part" v-if="checkedDetail.applyInfo.formData && checkedDetail.applyInfo.formData.detailList">
      <b>业务表单</b>
      <el-divider></el-divider>
      <el-descriptions border :column="2" :labelStyle="{ width: '150px', textAlign: 'center' }"
        :contentStyle="{ width: '300px' }">
        <!-- <template slot="extra">
          <code>审批编码：{{ checkedDetail.applyInfo.applyNo }}</code>
        </template> -->
        <template v-if="checkedDetail.applyInfo.formData && checkedDetail.applyInfo.formData.detailList">
          <el-descriptions-item v-for="item in checkedDetail.applyInfo.formData.detailList" :key="item.fieldId"
            :label="item.fieldTitle">
            <span v-if="![7, 9].includes(item.type)">{{ item.type === 2 || item.type === 11 ? item.fieldName :
              item.fieldValue }}</span>
            <span v-else>
              <el-link type="primary" :underline="false" v-for="(file, index) in item.fieldValue.split(',')"
                :key="index" :href="baseUrl + file" target="_blank" style="display: block;">{{ file }}
              </el-link>
            </span>
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <b>审批流程</b>
      <el-divider></el-divider>
      <el-table :data="checkedDetail.flowList">
        <el-table-column label="节点名称" prop="taskName" align="center"> </el-table-column>
        <el-table-column label="人员" align="center">
          <template slot-scope="{row}">
            <span v-if="row.userType === 'assignee'">{{ row.assigneeName }}</span>
            <span v-if="row.userType === 'candidate'">{{ row.candidate }}</span>
            <span v-else>{{ row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审批结果" align="center">
          <!-- 1-正常 2-退回 3-驳回 4-委派 5-转办 6-终止 -->
          <template slot-scope="{row}">
            <span v-if="row.comment">{{ row.comment.type | filterCommentType }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="审批意见" align="center">
          <template slot-scope="{row}">
            <span v-if="row.comment">{{ row.comment.comment }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作时间" align="center">
          <template slot-scope="{row}">
            <span v-if="row.comment">{{ row.finishTime }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="buttons" v-if="$parent.select.checked == 'todo'">
      <!-- <el-input v-model="comment" placeholder="请输入审核意见"></el-input> -->
      <el-button type="primary" @click="checkApply('agree')">通过</el-button>
      <el-button type="primary" @click="checkApply('reject')">驳回</el-button>
      <el-button type="primary" @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from "./api"
export default {
  name: "CheckDialog",
  data() {
    return {
      baseUrl: localStorage.getItem("baseUrl"),
      visible: false,
      title: "",
      checkedDetail: {
        applyInfo: {
          formData: {},
        },
        flowList: []
      },
      taskId: "",
      // comment: "",
      regionTree: [],
    }
  },
  filters: {
    filterCommentType(val) {
      switch (val) {
        case '1':
          return "正常"
        case '2':
          return "退回"
        case '3':
          return "驳回"
        case '4':
          return "委派"
        case '5':
          return "转办"
        case '6':
          return "终止"
        case '7':
          return "已提交"
        case '8':
          return "自动抄送"
        default:
          return '--'
      }
    }
  },
  methods: {
    async checkApply(type) {
      type === "agree"
        ? await api.agreeApply({
          taskIdList: [this.taskId],
          // comment: this.comment,
          comment: '',
        })
        : await api.rejectApply({
          taskId: this.taskId,
          // comment: this.comment,
          comment: '',
        })
      this.$message.success(type === "agree" ? "已通过申请" : "已拒绝申请")
      this.$parent.getApplyList()
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.check-dialog {
  .part {
    b {
      font-size: 24px;
      color: #333;
      font-weight: 900;

      &:nth-of-type(2) {
        display: inline-block;
        margin-top: 40px;
      }

    }

    .el-divider {
      margin: 10px 0 20px;
    }
  }
}
</style>